module.exports = __webpack_public_path__ + "static/blog-splash-3-thumbnail-90269a7f3c7e03241d17374c020ffb8b.jpg";